import { environment } from '@/environments/environment'

export default [
  { name: 'evaChatMessage', url: `${environment.evaAgentUrl}/webhook/chat-message`, method: 'post', notCancel: true }
]
